import moment from 'moment'
import { i18n, localesMap } from '@/i18n'

moment.updateLocale('en', {
  relativeTime: {
    M: '1 month',
    MM: '%d months',
    d: '1 day',
    dd: '%d days',
    future: 'in %s',
    h: '1 hour',
    hh: '%d hours',
    m: '1 min',
    mm: '%d mins',
    past: '%s ago',
    s: (value) => {
      const unit = value === 1 || value === 0 ? 'sec' : 'secs'
      return `${value} ${unit}`
    },
    y: '1 year',
    yy: '%d years'
  }
})

export function formatDate (date) {
  const m = moment(date).locale(localesMap[i18n.locale])

  if (!m.isValid()) return date
  return `${m.format('MM/DD/YYYY, HH:mm:ss')} (${m.fromNow()})`
}



// WEBPACK FOOTER //
// ./src/filters/index.js